import { Typography } from '@mui/material';

import { MarketingCtaBand } from '@/components/Marketing/blocks';
import { MarketingPageShell } from '@/components/Marketing/MarketingPageShell';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function AboutPage() {
  usePageMeta(
    'About Unbeatable Loans',
    'How Unbeatable Loans was founded and how our technology supports buyers and investors.'
  );
  return (
    <MarketingPageShell
      title="About Unbeatable Loans"
      subtitle="Founding story, technology, and how we work."
    >
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Founding Unbeatable Loans
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.85 }}
      >
        John Pastre started Unbeatable Loans after helping his fourteenth client
        buy a house without a realtor. The hardest parts of buying are not only
        finding a house—they are getting into the property and writing a strong
        contract. Buyers also need financing that keeps up; a purchase rarely
        gets off the ground without the right mortgage partner.
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.85 }}
      >
        That scramble when you find a home online and need to move fast is the
        problem Unbeatable Loans is built to solve. The mortgage industry lacked
        technology for brokers to advise on purchase offers from a place of
        confidence—most workflows are built to type data and wait. Unbeatable
        instead combines savings, mortgage insight, offer generation, and deal
        analysis in one platform.
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, lineHeight: 1.85 }}
      >
        Whether it is a first home or a seasoned investor refinancing across
        states, the focus is the same: the best purchase experience possible and
        long-term real estate knowledge for wealth built now or years from now.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        The Unbeatable Loans technology
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.85 }}
      >
        Unbeatable began as a way to create loan estimates without a separate
        application for every property. You can compare multiple opportunities
        at once—algorithm-driven, not dependent on bolt-on third-party data
        silos. We know what it costs to buy a home because we have helped
        hundreds of clients close—we are not only a tech company and not only a
        mortgage company; we are a home buying company.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Broker, not balance-sheet lender
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4, lineHeight: 1.85 }}
      >
        Staying a mortgage broker rather than becoming a lender keeps wholesale
        rates and origination costs in check while we scale the purchase
        experience. We can offer a wide range of structures for primary homes,
        small multifamily, LLCs, DSCR, and long-term leverage strategies.
      </Typography>

      <MarketingCtaBand
        title="Read the latest on our blog"
        to="/blog"
        buttonLabel="Visit the blog"
      />
    </MarketingPageShell>
  );
}
